class ApplicationElementManager {
  constructor(app, loaded = false) {
    this.app = app;
    this.loaded = loaded;
  }
  getHTMLElement(createElement) {
    let htmlElement;
    if (!createElement) {
      htmlElement = document.querySelector('body');
    }
    if (!htmlElement) {
      htmlElement = this.createIFrame(this.app.appId);
    }
    return htmlElement;
  }
  createIFrame(appId) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('id', `${appId}_iframe`);
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('title', 'SAS');
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.height = '100%';
    iframe.style.width = '100%';
    iframe.style.border = '0';
    iframe.style.position = 'absolute';
    return iframe;
  }
  initHTMLElement(src, useTransitionSplash) {
    const htmlElement = this.app.getHTMLElement();
    if (htmlElement instanceof HTMLIFrameElement) {
      const iframe = htmlElement;
      let iframeSrc = this.addUrlParameter(src, 'launchedFromAppSwitcher=true');
      if (useTransitionSplash) {
        iframeSrc = this.addUrlParameter(iframeSrc, 'useTransitionSplash=true');
      }
      iframe.src = iframeSrc;
      iframe.addEventListener('load', () => {
        this.loaded = true;
      });
    } else {
      this.loaded = true;
    }
  }
  addUrlParameter(url, parameter) {
    let operator = '?';
    if (url.includes('?')) {
      operator = '&';
    }
    return url + operator + parameter;
  }
  getWindow() {
    const htmlElement = this.app.getHTMLElement();
    if (htmlElement instanceof HTMLIFrameElement) {
      return htmlElement.contentWindow;
    }
    return window;
  }
  isLoaded() {
    return this.loaded;
  }
  queueMessage(message, executePostMessage) {
    const htmlElement = this.app.getHTMLElement();
    if (!(htmlElement instanceof HTMLIFrameElement)) {
      return;
    }
    const iframe = htmlElement;
    const appWindow = this.getWindow();
    iframe.addEventListener('load', () => {
      executePostMessage(message, appWindow);
    });
  }
  hideHTMLElement() {
    const htmlElement = this.app.getHTMLElement();
    if (htmlElement instanceof HTMLIFrameElement) {
      this.doHideElement(htmlElement);
    } else {
      const bodyChildNodes = document.querySelector('body')?.childNodes;
      for (const childNode of bodyChildNodes) {
        if (!(childNode instanceof HTMLIFrameElement) && childNode instanceof HTMLElement) {
          this.doHideElement(childNode);
        }
      }
    }
  }
  doHideElement(htmlElement) {
    htmlElement.setAttribute('active', 'false');
    htmlElement.style.display = 'none';
  }
  showHTMLElement() {
    const htmlElement = this.app.getHTMLElement();
    if (htmlElement instanceof HTMLIFrameElement) {
      this.doShowElement(htmlElement);
    } else {
      const bodyChildNodes = document.querySelector('body')?.childNodes;
      for (const childNode of bodyChildNodes) {
        if (!(childNode instanceof HTMLIFrameElement) && childNode instanceof HTMLElement && childNode.id !== 'sas-nc-splashscreen') {
          this.doShowElement(childNode);
        }
      }
    }
  }
  doShowElement(htmlElement) {
    htmlElement.setAttribute('active', 'true');
    htmlElement.focus();
    // NOTE: Do we need to restore original 'display' value?
    htmlElement.style.removeProperty('display');
  }
}
export default ApplicationElementManager;
//# sourceMappingURL=ApplicationElementManager.js.map